import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import React from 'react';
import { ModuleProvider } from '../components/ModuleProvider';

/**
 * ⚠️ DO NOT TOUCH - MUST BE FIRST EXTENSION ⚠️
 *
 * This extension provides the ModuleProvider context that enables useCurrentModule()
 * throughout the application. It MUST be the first extension in the array so that
 * all other extensions and their Providers can access the module context.
 *
 * Moving this extension or placing other extensions before it will cause:
 * "Error: useCurrentModule must be used within a ModuleProvider"
 *
 * IMPORTANT: Uses a mutable container pattern because the module object is
 * reassigned during createPremiumModule. The container.module is set AFTER
 * createPremiumModule completes, ensuring the Provider has the final module.
 *
 * Usage:
 *   const moduleContainer: ModuleContainer = { module: null };
 *   export const MyModule = createPremiumModule('name', [
 *     createModuleProviderExtension(moduleContainer),
 *     ...otherExtensions
 *   ], ...);
 *   moduleContainer.module = MyModule; // Set after creation
 */

export const createModuleProviderExtension = container => createModuleExtension(() => ({
  extensionName: 'ModuleProviderExtension',
  Provider: _ref => {
    let {
      children
    } = _ref;
    if (!container.module) {
      throw new Error('ModuleProviderExtension: module not initialized. ' + 'Ensure moduleContainer.module is set after createPremiumModule.');
    }
    return /*#__PURE__*/React.createElement(ModuleProvider, {
      module: container.module
    }, children);
  }
}));
//# sourceMappingURL=module-provider.extension.js.map